<template>
  <div class="usuario-avatar">
    <b-card no-header>
      <b-form>
        <b-row>
          <b-col class="avatar" cols="12" xl="12">
            <!-- <figure>
              <img
                :src="userAvatar"
                class="img-avatar"
                :alt="nombre" />
            </figure> -->
            <b-form-file 
              v-model="avatarFile" 
              class="mt-3" 
              accept=".jpg, .png, .jpeg" 
              placeholder="Seleccione la imagen o arrastrela hasta aquí">
            </b-form-file>
          </b-col>
        </b-row>
      </b-form>
      <div slot="footer">
        <b-button size="sm" variant="primary" class="footer-button"
          @click.prevent="save">Grabar</b-button>
        <b-button size="sm" variant="danger" class="footer-button" 
          @click.prevent="close">Cancelar</b-button>
      </div>
    </b-card>

    <mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      :modalVariant="modalVariant"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </mensaje>
  </div>
</template>

<script>
import Mensaje from  '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs'
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'usuarioperfil/getField',
  mutationType: 'usuarioperfil/updateField',
});

export default {
  name: 'Avatar',
  components: {
    Mensaje
  },
  mixins: [ 
    msjModal, 
  ],
  data () {
    return {
      modalMensaje: '',
      modalMsj: false,
      modalOkAction: null,
      modalHiddenAction: null,

      avatarFile: ''
    }
  },
  computed: {
    ...mapFields([
      'nombre',
      'avatar'
    ]),
    // userAvatar: function () {
    //   let server = process.env.VUE_APP_ROOT_API;
    //   let avatar = server + '/img/avatars/man.png';
      
    //   let fileAvatar = false;
    //   if (this.avatarFile) {
    //     if (this.avatarFile.name.trim() != '') {
    //       avatar = this.avatarFile;
    //       console.log(this.avatarFile);
    //       // avatar = this.avatarFile.name.trim();
    //       fileAvatar = true;
    //     }
    //   }

    //   if (!fileAvatar) {
    //     if (this.avatar) {
    //       if (this.avatar.trim() != '') {
    //         avatar = server + '/' + this.avatar.trim();
    //       }
    //     }
    //   }

    //   console.log(avatar);

    //   return avatar;
    // }
  },  
  created() {
  },  
  methods: {
    save() {
      let params = {
        file: this.avatarFile
      }
      this.showSpinner();
      this.$store.dispatch('usuarioperfil/updateAvatar', params)
        .then(() => {
          this.$emit('close');
        })
        .catch( error => {
          this.modalOkAction = null;
          this.modalHiddenAction = null;
          this.modalMensaje = error;
          this.modalVariant = 'danger';
          this.modalMsj = true;
        })
        .finally(() => this.hideSpinner());
    },
    close() {
      this.$emit('close');
    }
  },
  watch: {
    avatarFile (newVal, oldVal) {
      if (newVal) {
        // this.updateAvatar();
        // console.log('Avatar updated');
      }
    }    
  },
}
</script>

<style>
  .usuario-avatar img.img-avatar {
    max-width: 80px !important;
    height: auto;
  }
  .usuario-avatar .custom-file-label::after {
    content: 'Buscar' !important;
  }
</style>
